import * as React from 'react';
import MyMarker from '../../components/Marker';
import { ObjectCard } from '../../components/ObjectCard';
import { Box, Typography, Stack, Divider } from '@mui/material';
import { titleCase } from 'title-case';

const endpoint = "ctatrains";

const showCardContent = (obj) => { return true }

const ModuleMarker = (props) => {
    
    return (
        <MyMarker {...props} icondef={getIcon(props)} />
    )
}

const getIcon = (props) => { 
    
    var iconname = "mapicons/train/CtaTrain.png";
    return {
        url: iconname,
        anchor: new window.google.maps.Point(6, 15),
        scaledSize: new window.google.maps.Size(30, 30)
    };
}

const CardContent = (props) => {
    const obj = props.obj;
    return (
        <Stack spacing={1.5} sx={{ minWidth: 200 }}>
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <img src="/mapicons/train/CtaTrain.png" alt="CTA Train" style={{ width: 24, height: 24 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {obj.routeNum ? titleCase(obj.routeNum.toLowerCase()) : 'CTA Train'}
                    </Typography>
                </Box>
            </Box>
            <Stack spacing={1}>
                <VehicleId value={obj} />
            </Stack>
            <Divider />
            <LastUpdate value={obj} />
        </Stack>
    )
}

const VehicleId = props => {
    const obj = props.value;
    if(obj.vehId) {
        return (
            <Typography variant="body2">
                • Vehicle ID: {obj.vehId}
            </Typography>
        )
    }
    return null;
}

const LastUpdate = props => {
    const obj = props.value;
    if(obj.lastUpdate){
        return (
            <Typography variant="caption">
                Updated: {obj.lastUpdate}
            </Typography>
        )
    }
    return null;
}

const InfoWindow = (props) => {
    const module = props.module;
    const obj = props.icon;
    const MyCardContent = module.cardContent;
    const showCardContent = module.showCardContent;

    return (
        <Box className="map-popup-text" sx={{ 
            maxWidth: 300,
            '& .infoWindow': { border: 'none' }
        }}>
            {showCardContent(obj) ? <MyCardContent obj={obj} /> : null}
        </Box>
    )
}

export default {
    name: 'CTA Trains',
    label: 'CTA Train ',
    marker: ModuleMarker,
    showOnMap: true, //show on map layer filter
    mapLayerIcon: "/mapicons/train/CtaTrain.png",   
    showOnSidebar: false,
    sideBarCard: ObjectCard,
    endpoint: endpoint,
    defaultOn: false,
    updateDelay: 0,
    showCardContent: showCardContent,
    cardContent: CardContent,
    infoWindow: InfoWindow,
    cluster: false,
    publishLayer: "tasWebapp.ctatrains.enable" 
}